import { useState, useEffect } from 'react';
import { Box } from 'theme-ui';
import { Section } from '@snippets';
import { withInView } from '@utils';
import store, { useRecoilState } from '@store';

import { Schema } from './VideoWise.schema';
import { themed } from './VideoWise.theme';

export const VideoWise = withInView(
  themed(({ cms, theme }) => {
    const { embedContent, section } = cms;
    const [st, setSt] = useState(null);
    const [videoWiseLoaded] = useRecoilState(store.videoWiseLoaded);

    useEffect(() => {
      if (
        typeof window.__st === 'object' &&
        typeof window.initVideowise === 'function'
      ) {
        setSt(window.__st);
      }
    }, [videoWiseLoaded]);

    useEffect(() => {
      if (st) {
        window.initVideowise();
      }
    }, [st]);

    return embedContent ? (
      <Section section={section}>
        <Box
          sx={{
            ...theme.html,
          }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: cms.embedContent }}
        />
      </Section>
    ) : null;
  }),
  { triggerOnce: true }
);

VideoWise.displayName = 'VideoWise';
VideoWise.Schema = Schema;
